<template>
  <div :class="[$ps.fullscreen, $ps.center, 'admin-container']">
    <user-actions></user-actions>
    <h1>fireflies</h1>
    <v-sheet class="admin-wrapper">
      <v-tabs color="primary" v-model="createTab">
        <v-tab value="one">create</v-tab>
        <v-tab value="two">api</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-window v-model="createTab">
        <v-tabs-window-item value="one">
          <v-sheet>
            <v-form>
              <v-text-field 
                ref="title" v-model="ffCreate.title" label="title"
                ></v-text-field>
              <v-textarea
                ref="data" v-model="ffCreate.data" label="data"
                rows="6"
                ></v-textarea>
              <v-number-input
                ref="accessLevel" v-model="ffCreate.accessLevel"
                label="access level" controlVariant="default"
                min="0" max="3"
                ></v-number-input>
              <v-combobox 
                v-model="ffCreate.tags"
                multiple chips closable-chips label="tags"
                >
              </v-combobox>
              <v-alert v-if="ffCreate.err" type="error" dense>
                {{ ffCreate.err }}
              </v-alert>
              <v-btn @click="createFirefly()">
                create
              </v-btn>
            </v-form>
          </v-sheet>
        </v-tabs-window-item>
        <v-tabs-window-item value="two">
          <v-sheet>
            <h1>actions</h1>
            <h3>getFireflies actions</h3>
            <v-sheet>
              <v-btn @click="getFireflies()">getFireflies</v-btn>
            </v-sheet>
            <br />
            <v-divider />
            <h3>getFirefliesNoAuth actions</h3>
            <v-sheet>
              <v-btn @click="getFirefliesNoAuth()">getFirefliesNoAuth</v-btn>
            </v-sheet>
            <br />
            <v-divider />
            <h2>output</h2>
            <v-card>
              <ul>
                <li v-for="line in apiOutput" :key="line">
                  {{ line }} <br />
                </li>
              </ul>
            </v-card>
          </v-sheet>
        </v-tabs-window-item>
      </v-tabs-window>
    </v-sheet>
  </div>
</template>

<script>
import UserActions from '@/components/UserActions.vue';

export default {
  components: { UserActions },
  name: 'AdminView',
  data () {
    return {
      ffCreate: {
        title: '',
        data: '',
        accessLevel: 3,
        tags: [],
        err: ''
      },
      apiOutput: [],
      createTab: 'one'
    }
  },
  methods: {
    async getIdToken () {
      return await this.$auth.currentUser.getIdToken();
    },
    async createFirefly () {
      const body = {
        title: this.ffCreate.title,
        data: this.ffCreate.data,
        accessLevel: this.ffCreate.accessLevel,
        tags: this.ffCreate.tags
      };

      console.log(`posting firefly ${body}`);
      this.$api.post('/createFirefly', body).then(res => {
        console.log(res.data);
      });
    },
    getFireflies () {
      this.apiOutput = [];

      const body = {
        amount: 10
      }

      this.apiOutput.push('fetching fireflies!');

      this.$api.post('getFireflies', body).then(res => {
        this.apiOutput.push(JSON.stringify(res.data));
      });
    },
    getFirefliesNoAuth () {
      this.apiOutput = [];
      this.apiOutput.push('fetching fireflies!');

      this.$api.post('getFirefliesNoAuth').then(res => {
        this.apiOutput.push(JSON.stringify(res.data));
      });
    }
  }
}
</script>

<style scoped>
.admin-container {
  justify-content: flex-start;
}

.admin-wrapper {
  width: 50%;
}
</style>